/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { createContext, useEffect } from "react";
import { atom, useAtom } from "jotai";

import { AccordionProps } from "./Accordion";

export const UseStateContext = createContext<DesignStuff.Accordion.State>({ data: null });
export const UseHandlerContext = createContext<DesignStuff.Accordion.SelectHandler<string> | null>(null);
const accordionStateAtom = atom<Record<string, boolean> | null>(null);

export default function AccordionContainer({ activeId, children }: { activeId?: string; children: React.ReactNode }) {
	const [selectData, setSelectData] = useAtom<{ [key: string]: boolean } | null>(accordionStateAtom);

	const handleSelectAccordion = (id: AccordionProps["id"]) => {
		setSelectData((prev: DesignStuff.Accordion.State["data"]) => {
			return {
				...prev,
				[id]: selectData ? !selectData[id] : true
			};
		});
	};

	useEffect(() => {
		setSelectData((prev) => {
			const result = { ...prev };
			if (!activeId) return result;
			result[activeId] = true;
			return result;
		});
	}, [activeId]);

	return (
		<UseStateContext.Provider value={{ data: selectData }}>
			<UseHandlerContext.Provider value={handleSelectAccordion}>{children}</UseHandlerContext.Provider>
		</UseStateContext.Provider>
	);
}
